export default __webpack_public_path__ + "static/Turbinado-Bold-1640aafffbdea30c0350a132f81a511b.woff";